import dayjs from 'dayjs';

export const useLobby = () => {
  const lobbyId = `${dayjs().format('YYYYMMDD')}room`;

  return {
    lobbyId
  };
};